import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getMySummaryEngagement } from '../services';

export const useMySummaryEngagement = ({ includeCount, limit, offset }) =>
  useQuery([REACT_QUERY_KEYS.mySummary.mySummeryEngagement], () =>
    getMySummaryEngagement({ includeCount, limit, offset })
  );
